import React, { useState, useEffect } from "react";
import { concerts_title } from "./Home.json";
import { formatDateTime } from "../../helpers/helpers.jsx";
import Post01 from "./post01/Post01.jsx";
import Post02 from "./post02/Post02.jsx";
import Post03 from "./post03/Post03.jsx";
import Post04 from "./post04/Post04.jsx";
import Post05 from "./post05/Post05.jsx";
import Post06 from "./post06/Post06.jsx";
import "./Home.css";

const Home = ({ lang }) => {
  const [concerts, setConcerts] = useState([]);
  let show_concerts;

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    fetch("https://sancta-cecilia.cz/concerts_json.php?year=0")
      .then((res) => res.json())
      .then((data) => {
        data.sort((a, b) => a.datum.localeCompare(b.datum));
        setConcerts(data);
      });
  }, []);

  if (concerts.length > 0) {
    show_concerts = concerts
      .filter((concert) => concert.canceled === "0")
      .map((concert, index) => (
        <div key={index} className="sidebarConcertContainer">
          <div className="sidebarConcertDate">
            {formatDateTime(lang, concert.datum + "T" + concert.cas, true)}
          </div>
          <div className="sidebarConcertText">
            {concert["misto_" + lang.substring(0, 2)] === ""
              ? concert["misto_cs"]
              : concert["misto_" + lang.substring(0, 2)]}
          </div>
        </div>
      ));
  }

  return (
    <React.Fragment>
      {concerts.length > 0 && (
        <div className="postContainer">
          <div className="postHeader">
            <h1 className="postTitle">{concerts_title[lang]}</h1>
          </div>
          {show_concerts}
        </div>
      )}
      <Post06 lang={lang} />
      <Post05 lang={lang} />
      <Post04 lang={lang} />
      <Post03 lang={lang} />
      <Post02 lang={lang} />
      <Post01 lang={lang} />
    </React.Fragment>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx